import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import UserContext from '~/context/common/UserContext';
import UnlockTimerContext from '~/context/vdp/UnlockTimerContext';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import useNotifyAnalyticsStatus from '~/hooks/vdp/cta/useNotifyAnalyticsStatus';
import useHasVehicleNotifyStatus from '~/hooks/vdp/useHasVehicleNotifyStatus';

export default function useSendSoftNotify() {
  const { trackEvent } = useContext(AnalyticsContext);
  const { isInitialized } = useContext(UnlockTimerContext);
  const { vehicleAvailability } = useContext(UserVehicleContext);
  const { favorites } = useContext(UserContext);
  const vehicleNotifyStatus = useNotifyAnalyticsStatus();
  const hasVehicleNotifyStatus = useHasVehicleNotifyStatus();

  useEffectOnce(
    () => {
      trackEvent('Loaded Notify VDP', { status: vehicleNotifyStatus });
    },
    [trackEvent, vehicleNotifyStatus],
    Boolean(
      isInitialized &&
        vehicleAvailability.isLoaded &&
        favorites.isLoaded &&
        hasVehicleNotifyStatus
    )
  );
}
